import { Category } from "@mui/icons-material";

// utils/helpers.js
export const createSearchParams = (filters) => ({
  query: filters.query,
  title: filters.title,
  start_date: filters.startDate.toISOString().split('T')[0],
  end_date: filters.endDate.toISOString().split('T')[0],
  threshold: filters.threshold,
  value: filters.value,
  CityName: 'All',
  stateName: 'All',
  complaintType: 'All',
  complaintMode: 'All',
  companyName: 'All',
  complaintStatus: 'All',
  prompt: ''
});

export const createFeedbackSearchParams = (filters) => ({
  attribute: filters.attribute,
  Sector: filters.Sector,
  CompanyName: filters.CompanyName,
  Category: filters.Category,
  skip: filters.skip,
  limit: filters.limit,
})